"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResourceUrl = getResourceUrl;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _isResourceExist = require("./isResourceExist");

function getResourceUrl(_x, _x2) {
  return _getResourceUrl.apply(this, arguments);
}

function _getResourceUrl() {
  _getResourceUrl = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(resourceUrlWithoutExtension, extensions) {
    var i, testResourceUrl, testResourceExist;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < extensions.length)) {
              _context.next = 11;
              break;
            }

            testResourceUrl = "".concat(resourceUrlWithoutExtension).concat(extensions[i]);
            _context.next = 5;
            return (0, _isResourceExist.isResourceExist)(testResourceUrl);

          case 5:
            testResourceExist = _context.sent;

            if (!testResourceExist) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", testResourceUrl);

          case 8:
            i++;
            _context.next = 1;
            break;

          case 11:
            return _context.abrupt("return", '');

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getResourceUrl.apply(this, arguments);
}
//# sourceMappingURL=getResourceUrl.js.map